import { CustomerSortingType } from "./customerSortingType";

export class CustomerSearchRequestDto {
	public searchTerm: string = "";
	public isVolltextSearch: boolean = false;
	public tagIds: number[] = [];
	public countries: string[] = [];
	public sortingType: CustomerSortingType = CustomerSortingType.CustomerIdDescending;
}
